
import './App.css';
import React, {useState, useEffect} from 'react';
import Routes from './routes';
import AuthContextProvider from './context/AuthContext'

function App() {

  // const [loggedIn, setloggedIn] = useState(false);

  // function callbackFunction(childData) {
  //   setloggedIn(childData);
  // }
  return (
    <>
    <AuthContextProvider>
    <Routes/>
    </AuthContextProvider>
    </>
  );
}

export default App;
